import { 
  Code, 
  Shield, 
  Users, 
  Zap,
} from 'lucide-react';

export const services = [
  {
    icon: Code,
    title: "Web Design & Development",
    description: "We build fast, modern web applications using Symfony and React. From booking systems to custom platforms, we handle the full stack so you don't have to.",
    image: "/assets/service1.png",
    features: ["Symfony & React", "Full-Stack Solutions", "Mobile-First Design", "Optimization"]
  },
  {
    icon: Shield,
    title: "Software Protection",
    description: "Custom loaders and anti-crack systems that actually work. We protect your software from unauthorized access, reverse engineering, and license violations.",
    image: "/assets/service2.png",
    features: ["Anti-Crack Technology", "Code Obfuscation", "License Management", "Real-time Monitoring"]
  },
  {
    icon: Users,
    title: "IT Outsourcing",
    description: "Need experienced developers without the hiring headaches? We provide skilled engineers who do the work.",
    image: "/assets/service4.png",
    features: ["Expert Developers", "24/7 Support", "Agile Methodology", "Cost Effective"]
  }
];

export const testimonials = [
  {
    name: "Stanislav Krajnak",
    role: "Owner, SK Apartments",
    avatar: "https://tuke.win/sklogo.jpg",
    content: "TukeWIN transformed our entire digital infrastructure. Their web development team delivered beyond our expectations with cutting-edge solutions.",
    rating: 5,
    company: "GetRekt Ltd."
  },
  {
    name: "Denys Mazur",
    role: "Owner, IQ Apartments",
    avatar: "https://tuke.win/iqlogo.jpg",
    content: "TukeWIN developed an exceptional booking solution for our apartment rental business. The system streamlined our entire booking process and our customers love how easy it is to use. We're extremely satisfied with the results.",
    rating: 5,
    company: "IQ Apartments"
  },
  {
    name: "Maxime Cabarets",
    role: "Owner, Susano",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
    content: "The software protection services are unmatched. Our application security increased dramatically, and unauthorized access attempts dropped to zero.",
    rating: 5,
    company: "Susano"
  }
];

export const stats = [
  { number: "100+", label: "Projects Delivered" },
  { number: "99.9%", label: "Uptime Guarantee" },
  { number: "24/7", label: "Direct Support" },
  { number: "0", label: "Unsatisfied Clients" }
];